import React from 'react';
import { ErrorProps } from 'types';
import Button from 'components/Button/Button';
import { Link } from 'components/Link/Link';

import buttonStyles from 'components/Button/Button.module.scss';

import IconInfo from 'icons/ic_ErrorInfo.svg';

interface ComponentProps {
  styles: {
    [key: string]: string;
  };
  closeModal: () => void;
}

const ErrorModal: React.FC<ErrorProps & ComponentProps> = ({
  title,
  preBodyContent,
  body,
  buttons,
  styles,
  icon = IconInfo,
  closeModal
}) => {
  return (
    <div
      role="dialog"
      aria-labelledby="error-modal-title"
      aria-describedby="error-modal-description"
      className="Error-Modal"
      data-testid="error-modal"
    >
      <img src={icon} alt="Error" />
      <h2 id="error-modal-title">{title}</h2>
      {preBodyContent}
      <p id="error-modal-description" data-testid="error-modal-copy">
        {body}
      </p>
      <div data-testid="button-row" className={`${styles.ButtonRow} ${buttons.length === 1 ? styles.Single : ''}`}>
        {buttons.map(({ callback, url, label, level = 'high' }) => {
          if (url) {
            return (
              <Link
                key={label}
                href={url}
                openNewTab
                className={`${buttonStyles.Button} ${level === 'low' ? buttonStyles.low : ''}`}
                testId="link"
              >
                {label}
              </Link>
            );
          }

          if (callback) {
            return (
              <Button
                key={label}
                onClick={() => {
                  callback();
                  closeModal();
                }}
                level={level}
              >
                <span>{label}</span>
              </Button>
            );
          }

          return null;
        })}
      </div>
    </div>
  );
};

export default ErrorModal;
